/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import {
  AppBar,
  Container,
  Toolbar,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { useTheme } from "context/ThemeProvider";
import WebFont from "webfontloader";

function Footer() {
  const [ThemeMode, toggleTheme] = useTheme();
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["VT323", "Slackey"],
      },
    });
  }, []);
  return (
    <footer>
      <AppBar position="static" elevation={0}>
        <Box className="w-100 app-bar" sx={{ py: 5 }}>
          <Grid container className="container">
            <Grid
              item
              sm={12}
              xs={12}
              md={4}
              sx={{ pb: { xs: 5, md: 0, sm: 5 } }}
            >
              <Typography fontFamily="Slackey" fontSize={20} sx={{ pb: 2 }}>
                Postal Address
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                Key Mint
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                1101 E Cumberland Ave
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                Suite 201H-281
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                Tampa FL 33602
              </Typography>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              md={4}
              sx={{ pb: { xs: 5, md: 0, sm: 5 } }}
            >
              <Typography fontFamily="Slackey" fontSize={20} sx={{ pb: 2 }}>
                Company information
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                Key Mint
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                L21000488039
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                <a
                  href="mailto:sammie@sammie.com"
                  target="_self"
                  style={{
                    fontFamily: "VT323",
                    fontSize: 24,
                    textDecoration: "none",
                    color: ThemeMode == "dark" ? "#CCCCCC" : "#31302E",
                  }}
                >
                  Founder: sammie
                </a>
              </Typography>
              <Typography fontFamily="VT323" fontSize={24}>
                <a
                  data-auto-recognition="true"
                  href="mailto:sammie@sammie.com"
                  style={{
                    fontFamily: "VT323",
                    fontSize: 24,
                    textDecoration: "none",
                    color: ThemeMode == "dark" ? "#CCCCCC" : "#31302E",
                  }}
                >
                  sammie@sammie.com
                </a>
              </Typography>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              md={4}
              sx={{ pb: { xs: 5, md: 0, sm: 5 } }}
            >
              <Typography fontFamily="Slackey" fontSize={20} sx={{ pb: 2 }}>
                Follow
              </Typography>
              <Box display="flex">
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="social-logo-img"
                >
                  sammie
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="social-logo-img"
                >
                  sammie
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="social-logo-img"
                >
                  sammie
                </a>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Toolbar
          className="footer-bar"
          sx={{
            textAlign: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Typography
            fontFamily="VT323"
            fontSize={20}
            sx={{ pb: 2, textAlign: "center" }}
          >
            Copyright &copy; {new Date().getFullYear()} ChainCreatures
          </Typography>
          {/* <img src={footerWareWolf} alt="footerWareWolf" className="footerWareWolf-img" />
            <img src={footerJombieDog} alt="footerJombieDog" className="footerJombieDog-img" /> */}
        </Toolbar>
      </AppBar>
    </footer>
  );
}

export default Footer;
